import { SHELL } from "../shell/shell.const";

const DEVELOPER = 'desarrollador';
const DEVELOPMENT_REQUEST = 'solicitar-proyecto';

const DEVELOPMENT_INFO = 'info'
const DEVELOPMENT_MESSAGES = 'mensajes'

const DEVELOPMENT_DOCUMENTS = 'documentos'

const DEVELOPMENT_PROFILE = 'perfil'
const DEVELOPMENT_INFO_PROFILE = 'informacion-solicitante'
const DEVELOPMENT_DOCUMENTS_PROFILE = 'documentos-solicitante'
const DEVELOPMENT_CONFIG = 'configuracion'

const DEVELOPMENT_PROJECTS = 'proyectos'
const DEVELOPMENT_DETAILS_PROJECTS = 'info'

/** COMPLETAR REGISTRO RUTAS */
const DEVELOPER_FORM = 'completar-mi-perfil';
const DEVELOPER_FORM_STEP_ONE = 'informacion';
const DEVELOPER_FORM_STEP_TWO = 'documentos';
const DEVELOPER_FORM_STEP_THREE = 'informacion-legal';
const DEVELOPER_FORM_STEP_FOUR = 'documentos-legal';

const DEVELOPER_WITHDRAW_RESOURCES = 'retirar-recursos';

const DEVELOPMENT_MOVEMENTS = 'mis-movimientos';

export const DEVELOPER_ROUTES = {
  DEVELOPER,
  DEVELOPMENT_REQUEST,

  DEVELOPMENT_INFO,

  DEVELOPMENT_MESSAGES,

  DEVELOPMENT_DOCUMENTS,

  DEVELOPMENT_PROFILE,
  DEVELOPMENT_INFO_PROFILE,
  DEVELOPMENT_DOCUMENTS_PROFILE,
  DEVELOPMENT_CONFIG,

  DEVELOPMENT_PROJECTS,

  DEVELOPER_FORM,
  DEVELOPER_FORM_STEP_ONE,
  DEVELOPER_FORM_STEP_TWO,
  DEVELOPER_FORM_STEP_THREE,
  DEVELOPER_FORM_STEP_FOUR,

  DEVELOPER_WITHDRAW_RESOURCES,

  DEVELOPMENT_MOVEMENTS,

  ROUTE_DEVELOPER: `${SHELL}/${DEVELOPER}`,
  ROUTE_DEVELOPER_DEVELOPMENT_REQUEST: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_REQUEST}/estimacion`,
  ROUTE_DEVELOPER_REQUEST_STEP_1: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_REQUEST}/paso-1`,
  ROUTE_DEVELOPER_REQUEST_STEP_2: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_REQUEST}/paso-2`,
  ROUTE_DEVELOPER_REQUEST_STEP_3: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_REQUEST}/paso-3`,

  ROUTE_DEVELOPER_INFO: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_INFO}`,
  ROUTE_DEVELOPER_INFO_APPLICANT: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_INFO}/solicitante`,
  ROUTE_DEVELOPER_INFO_BANKING: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_INFO}/bancaria`,

  ROUTE_DEVELOPER_MESSAGES: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_MESSAGES}`,


  ROUTE_DEVELOPER_DOCUMENTS: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_DOCUMENTS}`,

  // INFORMACIÓN Y DOCUMENTOS POR PROYECTO
  /** `/s/desarrollador/perfil/informacion-solicitante` */
  ROUTE_DEVELOPER_INFO_PROFILE: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_PROFILE}/${DEVELOPMENT_INFO_PROFILE}`,
  /** `/s/desarrollador/perfil/documentos-solicitante` */
  ROUTE_DEVELOPER_DOCUMENTS_PROFILE: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_PROFILE}/${DEVELOPMENT_DOCUMENTS_PROFILE}`,
  /** `/s/desarrollador/perfil/informacion` */
  ROUTE_DEVELOPER_CONFIG: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_PROFILE}/${DEVELOPMENT_CONFIG}`,

  /** DEVELOPER PROJECTS */
  /** `/s/desarrollador/proyectos` */
  ROUTE_DEVELOPER_PROJECTS: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_PROJECTS}`,

  /** DEVELOPER UPDATE INFO */
  ROUTE_DEVELOPER_FORM: `${SHELL}/${DEVELOPER}/${DEVELOPER_FORM}`,
  ROUTE_DEVELOPER_FORM_STEP_ONE: `${SHELL}/${DEVELOPER}/${DEVELOPER_FORM}/${DEVELOPER_FORM_STEP_ONE}`,
  ROUTE_DEVELOPER_FORM_STEP_TWO: `${SHELL}/${DEVELOPER}/${DEVELOPER_FORM}/${DEVELOPER_FORM_STEP_TWO}`,
  ROUTE_DEVELOPER_FORM_STEP_THREE: `${SHELL}/${DEVELOPER}/${DEVELOPER_FORM}/${DEVELOPER_FORM_STEP_THREE}`,
  ROUTE_DEVELOPER_FORM_STEP_FOUR: `${SHELL}/${DEVELOPER}/${DEVELOPER_FORM}/${DEVELOPER_FORM_STEP_FOUR}`,


  ROUTE_PROFILE_WITHDRAWS_DEVELOPER: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_PROFILE}/${DEVELOPER_WITHDRAW_RESOURCES}`,

  /** DEVELOPER MY MOVEMENTS */
  /** /s/desarrollador/mis-movimientos */
  ROUTE_DEVELOPER_MY_MOVEMENTS: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_MOVEMENTS}`,
  /** /s/desarrollador/mis-movimientos/estado-de-operacion */
  ROUTE_DEVELOPER_MY_MOVEMENTS_OPERATION_STATUS: `${SHELL}/${DEVELOPER}/${DEVELOPMENT_MOVEMENTS}/estado-de-operacion`

};
